import classNames from 'classnames';
import type { MessageSize, MessageType, MessageVariant } from './Message.types';

const baseInteractivityClassName =
  'border-solid text-default bg-default focus-visible:outline-none focus-visible:ring';
const defaultStateClassName: { [Key in MessageVariant]: string } = {
  plain: `${baseInteractivityClassName} border`,
  floating: `${baseInteractivityClassName} border-l-xl shadow-2xl`,
};

const sizeClassName: { [Key in MessageSize]: string } = {
  small: 'text-xs rounded p-2xs',
  default: 'text-sm rounded p-xs',
};

const typeClassName: { [Key in MessageType]: string } = {
  info: 'border-status-info',
  success: 'border-status-success',
  warning: 'border-status-warning',
  error: 'border-status-error',
  plain: 'border-default',
};

export const getMessageClassNames = (
  variant: MessageVariant,
  size: MessageSize = 'default',
  type: MessageType = 'plain',
  className?: string,
): string =>
  classNames(
    className,
    'min-w-56 relative flex justify-between',
    'cursor-default',
    defaultStateClassName[variant],
    sizeClassName[size],
    typeClassName[type],
  );
